import React from 'react'
import PropTypes from 'prop-types'

import './index.css'

const Heading = ({title, actions}) => {
  const className = actions ? 'with-actions' : 'without-actions'
  return (
    <h2 className={`heading ${className}`}>
      <span className="heading-title">{title}</span>
      {!!actions &&
        <div className="heading-actions">
          {actions}
        </div>
      }
    </h2>
  )
}

Heading.propTypes = {
  title: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(PropTypes.node),
}

export default Heading
